import { render } from "./SlotFruit.vue?vue&type=template&id=ee76d442&scoped=true"
import script from "./SlotFruit.vue?vue&type=script&lang=js"
export * from "./SlotFruit.vue?vue&type=script&lang=js"

import "./SlotFruit.vue?vue&type=style&index=0&id=ee76d442&scoped=true&lang=css"

import exportComponent from "D:\\work\\application\\棋牌游戏5.0\\chesscards_5.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee76d442"]])

export default __exports__